import React from 'react';

import {FlowchartEditorMode} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/ProcessFlowchartEditorModeConstants';
import {ensureDefaultProcessesPluginRegistered} from 'processes/settings/ProcessTaskSchemaEditor';

import ACMExecutionFlowchartPane from './ACMExecutionFlowchartPane';
import {ExecutionFlowchartPaneProps} from './ExecutionFlowchartPaneTypes';
import PCMExecutionFlowchartPane from './PCMExecutionFlowchartPane';

export type {ExecutionFlowchartPaneProps} from './ExecutionFlowchartPaneTypes';

export default function ExecutionFlowchartPane(props: ExecutionFlowchartPaneProps): JSX.Element {
  ensureDefaultProcessesPluginRegistered({ignoreFlowchartConfigFlag: true});

  if (props.editorMode === FlowchartEditorMode.ACM_EDITOR) {
    return <ACMExecutionFlowchartPane {...props} />;
  }
  return <PCMExecutionFlowchartPane {...props} />;
}
